/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VehicleSearchStatus } from './VehicleSearchStatus';
import {
    VehicleSearchStatusFromJSON,
    VehicleSearchStatusFromJSONTyped,
    VehicleSearchStatusToJSON,
    VehicleSearchStatusToJSONTyped,
} from './VehicleSearchStatus';
import type { VehicleSummary } from './VehicleSummary';
import {
    VehicleSummaryFromJSON,
    VehicleSummaryFromJSONTyped,
    VehicleSummaryToJSON,
    VehicleSummaryToJSONTyped,
} from './VehicleSummary';

/**
 * Cross-sell rental car recommendations for a hotel booking
 * @export
 * @interface VehicleRecommendations
 */
export interface VehicleRecommendations {
    /**
     * Rental cars available at the nearest airport
     * @type {Array<VehicleSummary>}
     * @memberof VehicleRecommendations
     */
    airportCars?: Array<VehicleSummary>;
    /**
     * Rental cars available near the hotel
     * @type {Array<VehicleSummary>}
     * @memberof VehicleRecommendations
     */
    hotelCars?: Array<VehicleSummary>;
    /**
     * IATA code of the nearest airport
     * @type {string}
     * @memberof VehicleRecommendations
     */
    airportCode?: string;
    /**
     * Name of the nearest airport
     * @type {string}
     * @memberof VehicleRecommendations
     */
    airportName?: string;
    /**
     * 
     * @type {VehicleSearchStatus}
     * @memberof VehicleRecommendations
     */
    status: VehicleSearchStatus;
}



/**
 * Check if a given object implements the VehicleRecommendations interface.
 */
export function instanceOfVehicleRecommendations(value: object): value is VehicleRecommendations {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function VehicleRecommendationsFromJSON(json: any): VehicleRecommendations {
    return VehicleRecommendationsFromJSONTyped(json, false);
}

export function VehicleRecommendationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleRecommendations {
    if (json == null) {
        return json;
    }
    return {
        
        'airportCars': json['airport_cars'] == null ? undefined : ((json['airport_cars'] as Array<any>).map(VehicleSummaryFromJSON)),
        'hotelCars': json['hotel_cars'] == null ? undefined : ((json['hotel_cars'] as Array<any>).map(VehicleSummaryFromJSON)),
        'airportCode': json['airport_code'] == null ? undefined : json['airport_code'],
        'airportName': json['airport_name'] == null ? undefined : json['airport_name'],
        'status': VehicleSearchStatusFromJSON(json['status']),
    };
}

export function VehicleRecommendationsToJSON(json: any): VehicleRecommendations {
    return VehicleRecommendationsToJSONTyped(json, false);
}

export function VehicleRecommendationsToJSONTyped(value?: VehicleRecommendations | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'airport_cars': value['airportCars'] == null ? undefined : ((value['airportCars'] as Array<any>).map(VehicleSummaryToJSON)),
        'hotel_cars': value['hotelCars'] == null ? undefined : ((value['hotelCars'] as Array<any>).map(VehicleSummaryToJSON)),
        'airport_code': value['airportCode'],
        'airport_name': value['airportName'],
        'status': VehicleSearchStatusToJSON(value['status']),
    };
}

